import { render, staticRenderFns } from "./UserWiseVerification.vue?vue&type=template&id=7e8ceca6&"
import script from "./UserWiseVerification.vue?vue&type=script&lang=js&"
export * from "./UserWiseVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports